import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import AgenteIaBarbearia from "@/pages/AgenteIaBarbearia";

export const Route = createFileRoute("/agente-ia-barbearia")({
  head: () => buildHead({
    title: "Agente de IA para Barbearia no WhatsApp: agenda cheia todo dia",
    description: "Sua barbearia agendando cortes sozinha no WhatsApp e no Instagram, 24h: o Agente de IA marca, confirma e lembra o cliente, reduzindo faltas. CRM incluso e implantação assistida.",
    path: "/agente-ia-barbearia",
  }),
  component: AgenteIaBarbearia,
});
